import React from 'react';
import { withAsyncActions } from 'react-async-client';

import SettingsModal from './SettingsModal';

import { getWorksheetListSettings, postWorksheetListSettings } from 'actions/asyncActions';
import { defaultWorksheetListSettings } from 'constants/defaultSettings';

export default withAsyncActions({
    getSettings: getWorksheetListSettings,
    postSettings: postWorksheetListSettings.withOptions({ autoReset: true })
})(
    props => (
        <SettingsModal
            {...props}
            defaultSettings={defaultWorksheetListSettings}
            translatePrefix='worksheet.headers.'
        />
    )
);
